<template>
  <button
    class="scroll-to-content-button"
    type="button"
    v-show="hasContent"
    @click="scrollToContent"
  >
    {{ text }}
  </button>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import * as scrollToElement from 'scroll-to-element';
  import {intersectionService} from '../../utilities/js/intersectionService/intersectionService';

  @Options({
    name: 'scroll-to-content-button'
  })
  export default class ScrollToContentButton extends Vue {
    @Prop()
    text: string;

    @Prop()
    contentSelector: string;

    @Prop({default: 70})
    offset: number;

    hasContent: boolean = false;
    content: unknown;

    mounted() {
      this.content = document.querySelector(this.contentSelector);
      if (this.content) {
        this.hasContent = true;
      }
    }

    scrollToContent() {
      const tween = scrollToElement(this.content, {duration: 500, offset: -this.offset});
      intersectionService.disable();
      tween.on('end', () => {
        setTimeout(() => {
          intersectionService.enable();
          intersectionService.activateAll('lazyload');
        }, 800);
      });
    }
  }
</script>
